export type IDomainEventId = string

export enum DomainEventType {
  BroadcastFailure = 'intake.broadcast_failure',
  BroadcastSuccess = 'intake.broadcast_success',
  DataInstrumentCreated = 'intake.data_instrument_created',
  DataInstrumentViewAdded = 'intake.data_instrument_view_added',
  EntryAuthenticated = 'intake.entry_authenticated',
  EntryCreated = 'intake.entry_created',
  EntryResponseDeleted = 'intake.entry_deleted',
  EntryWitnessed = 'intake.entry_witnessed',
  IntegrationCreated = 'intake.integration_created',
  PatientCreated = 'intake.patient_created',
  PatientUpdated = 'intake.patient_updated',
  VisitCompleted = 'intake.visit_completed',
  VisitCreated = 'intake.visit_created',
  VisitDefinitionCreated = 'intake.visit_definition_created',
  VisitUpdated = 'intake.visit_updated',
}

export interface IDomainEvent {
  data: Map<string, string>
  id: IDomainEventId
  type: DomainEventType
  subject: string
  source: string
  time: string
  userId?: string
}

export interface IUseDomainEvents {
  domainEvents: IDomainEvent[]
  pageCount: number
  totalNumberOfRecords: number
  isLoading: boolean
  refresh: (
    pageNumber: number,
    recordsPerPage: number,
    pausedTime: Date,
    sources: string[],
    subjects: string[],
    types: string[],
  ) => void
}

export interface IUseDomainEventFilters {
  sources: string[]
  subjects: string[]
  types: string[]
}
